import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-022761be"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "page-wrapper"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "page-bg"
}, null, -1));

const _hoisted_3 = {
  class: "content-wrapper"
};
const _hoisted_4 = {
  class: "lecture-title"
};
const _hoisted_5 = {
  class: "lecture-main"
};
const _hoisted_6 = {
  key: 0
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "end-lecture"
}, "培训回顾", -1));

const _hoisted_8 = {
  class: "lecture-end-list"
};
import Head from 'components/Head';
import LectureCard from './components/lectureCard';
import LectureEndCard from './components/lectureEndCard';
import { getUrlParams } from '@/plugins/utils';
import { Empty } from 'zhs-components';
export default {
  setup(__props) {
    const $http = inject('$http');
    const menuId = getUrlParams('menuId');
    const menuInfo = ref({});
    const userInfo = ref();
    provide('userInfo', userInfo);

    const getUserInfo = info => {
      userInfo.value = info;
    }; // 获取进行未进行培训列表


    const lectureList = ref([]);

    const getLectureList = async () => {
      const res = await $http.getLectureList({
        menu_id: menuId,
        start_time_sort: 1,
        live_status: 1
      });
      console.log('进行未进行培训列表', res);
      lectureList.value = res.content || [];
    };

    getLectureList(); // 获取已结束培训列表

    const finishLectureList = ref([]);
    const pageInfo = reactive({
      pageNum: 1,
      pageSize: 8,
      total: 0
    });

    const getFinishLecture = async () => {
      const res = await $http.getLectureList({
        menu_id: menuId,
        start_time_sort: 2,
        '_pageable.page': pageInfo.pageNum - 1,
        '_pageable.size': pageInfo.pageSize,
        live_status: 2
      });
      console.log('已结束培训列表', res);
      finishLectureList.value = res.content || [];
      pageInfo.total = +res.totalElements || 0;
    };

    getFinishLecture(); // 分页改变时

    const pageIndexChange = index => {
      pageInfo.pageNum = index;
      getFinishLecture();
    };

    return (_ctx, _cache) => {
      const _component_el_pagination = _resolveComponent("el-pagination");

      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createVNode(_unref(Head), {
        menuInfo: menuInfo.value,
        "onUpdate:menuInfo": _cache[0] || (_cache[0] = $event => menuInfo.value = $event),
        onGetUserInfo: getUserInfo
      }, null, 8, ["menuInfo"]), _hoisted_2, _createElementVNode("section", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h3", null, _toDisplayString(menuInfo.value.nav_name), 1)]), _createElementVNode("div", _hoisted_5, [lectureList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lectureList.value, (item, index) => {
        return _openBlock(), _createBlock(_unref(LectureCard), {
          key: item.id,
          lectureData: item,
          index: index,
          onUpdateStatus: getLectureList
        }, null, 8, ["lectureData", "index"]);
      }), 128))])) : (_openBlock(), _createBlock(_unref(Empty), {
        key: 1,
        text: "暂无数据"
      })), _hoisted_7, _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(finishLectureList.value, (item, index) => {
        return _openBlock(), _createBlock(_unref(LectureEndCard), {
          index: index,
          key: item.id,
          finishLecture: item
        }, null, 8, ["index", "finishLecture"]);
      }), 128))]), _createVNode(_component_el_pagination, {
        class: "lecture-pagination",
        background: "",
        layout: "prev, pager, next",
        onCurrentChange: pageIndexChange,
        "current-page": _unref(pageInfo).pageNum,
        total: _unref(pageInfo).total,
        "page-size": _unref(pageInfo).pageSize,
        "hide-on-single-page": ""
      }, null, 8, ["current-page", "total", "page-size"])])])]);
    };
  }

};